/** Whether the desktop app may open or create projects/files. */
import { getCloudSession } from "./cloudAuth";
import { isDesktopLicenseActive } from "./desktopLicense";
import { isTauri } from "./runtime";

/**
 * try. / browser demo is ungated. Desktop requires a cloud session or an
 * installed offline license blob.
 */
export async function canAccessWorkspace(): Promise<boolean> {
  if (isTauri() === false) return true;
  if (getCloudSession() !== null) return true;
  return isDesktopLicenseActive();
}
